import { createContext, useContext, useState } from "react";

type SelectedRows = Record<string, boolean>;
type OnSelectRowHandler = (
  updaterOrValue: SelectedRows | ((rows: SelectedRows) => SelectedRows),
) => void;

const CasesTableContext = createContext<{
  selectedRows: SelectedRows;
  onSelectRow: OnSelectRowHandler;
}>({
  selectedRows: {},
  onSelectRow: () => {},
});

export const CasesTableProvider: React.FC<{
  children: React.ReactNode;
}> = ({ children }) => {
  const [selectedRows, setSelectedRows] = useState<SelectedRows>({});

  return (
    <CasesTableContext.Provider
      value={{
        selectedRows,
        onSelectRow: setSelectedRows,
      }}
    >
      {children}
    </CasesTableContext.Provider>
  );
};

export const useCasesTableContext = () => {
  const context = useContext(CasesTableContext);

  if (!context) {
    throw new Error(
      "useCasesTableContext can only be called within CasesTableContext",
    );
  }

  return context;
};
